import BreakTimer from './BreakTimer'
import enhance from './BreakTimer.enhancer'

export default enhance(BreakTimer)



// WEBPACK FOOTER //
// ./src/components/BreakTimer/index.js